"use client";

import { Card, CardContent, CardHeader, cn } from "@saridana-core/react-ui-kit";
import { TContentCard, TProductAboutSection } from "@shared/types";
import Image from "next/image";

export function ProductAboutSection({ title, description, image, items }: TProductAboutSection) {
  return (
    <section className="py-20 md:py-[100px] lg:py-[120px] bg-white">
      <div className="container relative">
        <div className="flex gap-9 sm:gap-[40px] lg:gap-[60px] w-full flex-col sm:flex-row sm:items-stretch">
          <div className="sm:w-[45%] sm:min-w-[45%]">
            {image?.data?.attributes?.url && (
              <Image
                className="rounded-2xl w-full h-full max-h-[280px] sm:max-h-full object-top object-cover"
                src={image?.data?.attributes?.url}
                height={image?.data?.attributes?.height}
                width={1000}
                alt={image?.data?.attributes?.alternativeText || image?.data?.attributes?.name || "Product Information Section"}
              />
            )}
          </div>

          <div
            className={cn(
              "flex flex-col space-y-6 self-center",
              image?.data?.attributes?.url ? "text-left xl:max-w-[50rem]" : "text-center xl:max-w-[80%] mx-auto",
            )}
          >
            <h3 className="text-[36px] lg:text-[56px] leading-[112%] font-bold">{title || "Product Information Title"}</h3>
            <p className="text-xl lg:text-2xl leading-[134%] text-gray-700">{description || "Product Information Description"}</p>
          </div>
        </div>

        {items && items?.length > 0 && <ProductAboutCards items={items} />}
      </div>
    </section>
  );
}

export function ProductAboutCards({ items }: { items: TContentCard[] }) {
  return (
    <div className={cn("mt-[60px] sm:mt-16 md:mt-[100px] grid grid-cols-1 md:grid-cols-3 gap-6")}>
      {items?.map((item: TContentCard) => (
        <Card key={`product-item-${item.id}`} className="border-none shadow-none">
          {item?.icon?.data?.attributes?.url && (
            <CardHeader>
              <Image
                className="size-[88px] sm:size-[100px] flex-shrink-0 object-contains mx-auto"
                src={item?.icon?.data?.attributes?.url}
                height={item?.icon?.data?.attributes?.height}
                width={item?.icon?.data?.attributes?.width}
                alt={item?.icon?.data?.attributes?.alternativeText || item?.icon?.data?.attributes?.name || "Product About Item Section"}
              />
            </CardHeader>
          )}

          <CardContent>
            <h3 className="text-center font-bold text-2xl lg:text-[28px] leading-[130%] mb-3 lg:mb-4">{item.title}</h3>
            <p className="text-center text-lg leading-[146%] text-gray-700">{item.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
